const CATEGORY_SELECTOR_MODE = {
  CATEGORY: { value: 1, text: "Category" },
  SUB_CATEGORY: { value: 2, text: "SubCategory" },
}

export { CATEGORY_SELECTOR_MODE }
